import PopUpWindow from "app/widgets/PopUpWindow/PopUpWindow";
import locale from "common/managers/locale";
import join from "common/helper/join";

var mapping = {
    "save.continue": "saveContinue",
    "continue": "continue",
    "disable": "disable",
    "discard": "discard",
    "save.as": "saveAs",
    "check.in.continue": "checkInContinue",
    "cancel": "cancel",
    "revoke": "revokeContinue",
    "clear": "clear",
    "reset": "reset",
    "delete": "delete",
    "add": "add",
    "goToLogin": "close",
    "refresh": "refresh",
    "release": "release",
    "logout": "logout",
    "purge": "purge",
    "cancelEdit": "cancelEdit",
    "closeLegalCase": "closeLegalCase",
    "releaseAndClose": "releaseAndClose",
    "browse": "continue",
    "clearUser": "continue",
    "download": "download",
    "redistribute": "continue",
    "setAsDefault": "save"
};

export default {

    /**
     * This should be the only function in this class that actually creates a dialog.  All of the others are just specializations of this.
     * @param content jQuery element to use as the dialog message content
     * @param title localization key for the title
     * @param buttons array of buttons that should be used. Must exist in the mapping
     * @param linked An optional promise that will be used to control the loading indicator after button press
     * @param pbutton default and focused button (optional)
     * @returns {*} Promise that is resolved when a button is pressed or rejected when the dialog is closed
     * @private
     */
    _generic: function(content, title, buttons, linked, pbutton) {
        var win = $("<div></div>").attr("id", "confirmation");
        content.attr("id", "confirmation_content");
        win.append(content);
        var popup = new PopUpWindow(win, {
            buttons: buttons,
            title: locale.get(title),
            simpleDialog: true,
            helpPage: false,
            windowClass: "smallDialog confirmation",
            primaryButton: pbutton
        });
        popup.wrapper.attr("aria-describedby", content.attr("id"));
        kendo.bind(win.find("ul"));
        var deferred = $.Deferred();
        popup.open();
        popup.failOnClose(deferred);
        var promise = deferred;

        $.each(buttons, function(i) {
            var event = buttons[i].event ? buttons[i].event : (mapping[buttons[i]] || buttons[i]);
            popup.one(event, function() {
                var all = {};
                $.each(mapping, function(j, e) {
                    all[e] = false;
                });
                all[event] = true;
                deferred.resolve(all);
            })
        });

        var clean = function() {
            kendo.destroy(win);
            kendo.unbind(win);
            win.remove();
        };
        if (linked) {
            promise.done(function() {
                popup.linkRequest(linked);
            });
            linked.always(clean);
        } else {
            promise.always(clean);
        }
        return promise;
    },

    /**
     * Cancel the last confirmation dialog.
     */
    cancel: function() {
        //Calling close() on the popup doesn't work.  This is pretty ugly, but works.
        $("#confirmation_btn_cancel").click();
    },

    _confirm: function(message, title, buttons, linked, pbutton, useHTML) {
        var content = $("<div></div>").addClass("dialogContent");
        if (useHTML) {
            content.html(message);
        } else {
            content.text(message);
        }
        return this._generic(content, title, buttons, linked, pbutton);
    },

    /**
     * Create a generic confirmation dialog
     * @param message the locale key for the dialog text
     * @param title title key
     * @param buttons array of buttons
     * @param pbutton default and focused button (optional)
     * @returns {*} promise
     */
    generic: function(message, title, buttons, pbutton) {
        return this._confirm(locale.get(message), title, buttons, null, pbutton, false);
    },

    /**
     * Create a generic confirmation dialog, passing the actual message to be used
     * as dialog text, rather than a locale key.
     * @param message the actual message text, already localized. This takes HTML.
     * @param title the locale key for the title text
     * @param buttons the array of buttons to use on the dialog
     * @param linked A request used to determine when a loading indicator is shown
     * @param pbutton default and focused button (optional)
     * @returns {*}
     */
    genericNonLocalized: function(message, title, buttons, linked, pbutton) {
        return this._confirm(message, title, buttons, linked, pbutton, true);
    },

    /**
     * Displays a confirmation window asking if the user really wants to delete a group of items.
     *
     * Returns a promise that is resolved if the delete should continue, and rejected if it should fail.
     * @param items
     * @param message Optional locale key to use for message.  Defaults to confirm.delete
     * @param linked A request used to determine when a loading indicator is shown
     */
    confirmDelete: function(items, message, linked) {
        return this._confirm(locale.get(message ? message : "confirm.delete", join(items)), "confirm.delete.title", ["delete", "cancel"], linked);
    },

    /**
     * Displays a confirmation window asking if the user really wants to delete a group of children from a parent.
     *
     *
     * @param parentName Name of parent
     * @param childCount Number of children to be deleted
     * @param message Locale key to use for message
     * @param linked A request used to determine when a loading indicator is shown
     * @returns {*}
     */
    confirmDeleteChildren: function(parentName, childCount, message, linked) {
        return this._confirm(locale.get(message, childCount, parentName), "confirm.delete.title", ["delete", "cancel"], linked);
    },

    /**
     * Displays a confirmation window asking if the user really wants to revoke something from a group of items.
     *
     * @param message Optional localized message to display.
     * @returns {*}
     */
    confirmRevoke: function(message) {
        return this._confirm(locale.get(message), "confirm.revoke.title", ["revoke", "cancel"]);
    },

    /**
     * Displays a confirmation window asking if the user wants to continue logging out.
     */
    confirmLogout: function() {
        return this._confirm(locale.get('logout.confirm.message'), 'logout.confirm.title', ["logout", "cancel"]);
    },

    /**
     * Display a confirmation window asking if the user is sure about activating a new item.
     * @param linked
     */
    confirmActivateWorking: function(linked) {
        return this._confirm(locale.get("activate.working.confirm"), "activate.confirm.title", [{
            id: "activateWorking",
            localized: "activate",
            event: "continue"
        }, "cancel"], linked);
    },

    /**
     * Display a confirmation window asking if the user would like to save or discard unsaved changes.
     *
     * Returns a promise object. This promise is resolved with fields save and discard with the appropriate option set to true.
     * The promise is rejected if the user closes the window.
     * @param name
     * @returns {*}
     */
    confirm: function(name) {
        return this._confirm(locale.get("dashboard.unsaved.changes.desc", name), "dashboard.unsaved.changes.title", ["save.continue", "discard"]);
    },

    // ---------- CAUTION TYPE MESSAGES ---------- //

    caution: function(message, buttons, link, pbutton, title = "caution") {
        var content = $("<div></div>").addClass("dialogContent")
            .append($("<span class=\"iconMoon left cautionDialog\" aria-hidden='true'>w</span>"))
            .append($("<p class=\"cautionMessage right\"></p>").html(message))
            .append($("<div class=\"clear\"></div>"));
        return this._generic(content, title, buttons, link, pbutton);
    },

    discardCaution: function() {
        return this.caution(locale.get("confirm.unsaved"), ["save.continue", "discard"]);
    },

    /**
     * Show a caution dialog related to specific things.
     * @param names Name of things to caution about.
     */
    discardCautionWithNames: function(names) {
        return this.discardCautionWithMessage(locale.get("confirm.unsaved.specific", names));
    },

    /**
     * Show a caution dialog with a custom message.
     * @param message
     * @returns {*}
     */
    discardCautionWithMessage: function(message) {
        return this.caution(message, ["save.continue", "discard", "cancel"])
    },

    /**
     * Display a caution window asking if the user would like to save as or discard when a thing has been checked in
     * @param thing
     * @param altMessage an alternative message to use
     * @returns {*} promise
     */
    checkedInCaution: function(thing, altMessage) {
        return this.caution(locale.get(altMessage || "dashboard.checkedIn.desc", thing), ["save.as", "discard"]);
    },

    checkInThenAction: function(users, names, thing, action, message, linked) {
        return this.caution(
            locale.get(message || "dashboard.checkInDelete.desc", join(names), join(users), action, thing), ["check.in.continue", "cancel"],
            linked
        );
    }
}
